import {
  createHttpClient,
  HttpClientContext,
  useAuthUtils,
} from '@hakimo-ui/hakimo/util';
import { ReactElement, useCallback, useMemo } from 'react';

interface Props {
  children: ReactElement;
}

export function HttpClientProvider(props: Props) {
  const { children } = props;
  const { getAccessToken, logout } = useAuthUtils();

  const getAccessTokenWrapper = useCallback(async () => {
    return getAccessToken();
  }, [getAccessToken]);

  const httpClient = useMemo(
    () => createHttpClient(getAccessTokenWrapper, logout),
    [getAccessTokenWrapper, logout]
  );

  return (
    <HttpClientContext.Provider value={httpClient}>
      {children}
    </HttpClientContext.Provider>
  );
}

export default HttpClientProvider;
